import { InteractionType } from '@azure/msal-browser';

export type CoreMsalInteractionType = InteractionType.Redirect | InteractionType.Popup;

export interface CoreAuthMsalConfig {
  clientId: string;
  tenantName: string;
  signInPolicy: string;
  signInPolicy2?: string;
  redirectUri: string;
  authorityDomain?: string;
  scopes?: string[];
  interactionType?: CoreMsalInteractionType;
}

export interface CoreAuthApiConfig {
  apimBaseUrl: string;
  apiManagementUrl?: string;
  subscriptionKey?: string;
  protectedResourcePatterns?: string[];
  whitelistPatterns?: string[];
}

export interface CoreAuthSessionCookieNames {
  userGuid: string;
  businessPlanGuid: string;
  productGuid: string;
  companyGuid: string;
}

export interface CoreAuthSessionConfig {
  cookieNames: CoreAuthSessionCookieNames;
  loginRoute?: string;
}

export interface CoreAuthEndpoints {
  loginUrl?: string;
  authUrl?: string;
}

export interface CoreAuthConfig {
  isLocalWeb: boolean;
  msal: CoreAuthMsalConfig;
  api: CoreAuthApiConfig;
  session: CoreAuthSessionConfig;
  endpoints?: CoreAuthEndpoints;
  offlineTokenStorageKey?: string;
}

export interface CoreLoginRequest {
  userName?: string;
  email?: string;
  password?: string;
  [key: string]: string | number | boolean | null | undefined;
}

export interface CoreAuthenticatedModel {
  UserGuid: string;
  BusinessPlanGuid: string;
  ProductGuid: string;
  CompanyGuid: string;
  [key: string]: unknown;
}

export interface ArkikEnvironmentLike {
  isLocalWeb: boolean;
  B2C_clientId: string;
  B2C_tenantName: string;
  B2C_signInPolicy: string;
  B2C_signInPolicy2?: string;
  B2C_redirectUri: string;
  APIM: string;
  apiManagmet: string;
  apimSubscriptionKey?: string;
  ApiLogin?: string;
  ApiAuth?: string;
  apiLogin?: string;
  apiAuth?: string;
  UserGuid: string;
  BusinessPlanGuid: string;
  ProductGuid: string;
  CompanyGuid: string;
}
